<template>
  <div>
    <div class="title">入库单扫描</div>
    <div style="padding: 0 0 13px 20px">
      入库单号：
      <el-input
          ref="input"
          v-model.trim="billNo"
          :disabled="loading"
          placeholder="请扫描入库单号"
          style="width: 400px"
          @keyup.enter.native="scanHandle"/>
    </div>
    <div class="title" style="margin-top: 20px">入库单明细</div>
    <Table border stripe :columns="columns" :data="data">
      <template slot="serialNo" slot-scope="scope">
        <el-input
            v-if="scope.row.requireSerialQuantity"
            v-model="scope.row.serialNo"
            :disabled="serialLoading"
            placeholder="请扫描物料序列号"
            @keyup.enter.native="saveHandle(scope.row)"/>
      </template>
      <template slot="action" slot-scope="scope">
        <el-button v-if="scope.row.snSerialNos.length > 0" type="primary" @click="$refs.serialList.open(scope.row)">
          已扫序列号
        </el-button>
      </template>
    </Table>
    <sn-serial-dialog ref="serialList" @dialog-close="reload"/>
  </div>
</template>

<script>
  import SnSerialDialog from "@/views/information/SnSerial/SnSerialDialog";
  export default {
    components: { SnSerialDialog },
    data() {
      return {
        loading: false,
        serialLoading: false,
        billNo: "",
        data: [],
        columns: [
          {
            type: "index",
            width: 55,
            align: "center",
          },
          {
            title: "物料编号",
            key: "materialNo",
            width: 110,
            align: "center",
            tooltip: true,
          },
          {
            title: "物料名称",
            key: "materialName",
            minWidth: 300,
            tooltip: true,
          },
          {
            title: "物料规格",
            key: "specification",
            minWidth: 120,
            tooltip: true,
          },
          {
            title: "仓库名称",
            key: "warehouseName",
            minWidth: 120,
            tooltip: true,
          },
          {
            title: "仓位名称",
            key: "locationName",
            minWidth: 120,
            tooltip: true,
          },
          {
            title: "出库数量",
            key: "quantity",
            width: 90,
            align: "center",
          },
          {
            title: "单位",
            key: "unitName",
            width: 80,
            align: "center",
          },
          {
            title: "物料序列号",
            key: "serialNo",
            width: 200,
            slot: "serialNo",
          },
          {
            title: "操作",
            slot: "action",
            width: 120,
            align: "center",
          },
        ],
      };
    },

    mounted() {
      this.$refs.input.focus();
    },

    methods: {
      reload() {
        this.getDetails(this.billNo);
      },
      // 扫描
      scanHandle() {
        if (!this.billNo) {
          this.$confirm("出库单号不能为空", "错误", {
            type: "error",
            showConfirmButton: false,
          });
          return;
        }
        this.loading = true;
        this.getDetails(this.billNo);
      },
      // 获取序列号
      getDetails(inStockBillNo) {
        this.$http.get("basic", `scanRecords/inStock/check/${inStockBillNo}`).then((res) => {
          if (res.success) {
            let result = res.data.filter((item) => item.requireSerialQuantity);
            if (!result.length) {
              this.submitScan();
            } else {
              this.data = res.data;
            }
          }
          this.loading = false;
          this.serialLoading = false;
        }).catch(() => {
          this.loading = false;
          this.serialLoading = false;
        });
      },
      // 扫描
      submitScan() {
        this.loading = true;
        this.data = [];
        this.$http.post("basic", `scanRecords/inStock/${this.billNo}`).then((res) => {
          if (res.success) {
            this.$message.success("扫描成功");
            this.billNo = "";
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      // 保存序列号
      saveHandle(row) {
        if (row.serialNo) {
          this.serialLoading = true;
          this.$http.post("basic", "snSerialNos/inStock", row).then((res) => {
            if (res.success) {
              if (res.data > 0) {
                this.$message.success("序列号录入成功，还需录入 " + res.data + " 个");
              } else {
                this.$message.success("序列号录入成功");
              }
              this.getDetails(this.billNo);
            }
            this.serialLoading = false;
          }).catch(() => {
            this.serialLoading = false;
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
.title {
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
  padding-bottom: 5px;
}
</style>
